/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export enum RoadLorryClass {
    Class35 = 'Class3_5',
    Class75 = 'Class7_5',
    Class12 = 'Class12',
    Class20 = 'Class20',
    Class26 = 'Class26',
    Class40 = 'Class40',
    Class44 = 'Class44',
    Class50 = 'Class50',
    Class60 = 'Class60',
    ClassGt60 = 'ClassGt60',
    Class16Klbs = 'Class16Klbs',
    Class26Klbs = 'Class26Klbs',
    Class44Klbs = 'Class44Klbs',
    Class60Klbs = 'Class60Klbs',
    Class80Klbs = 'Class80Klbs',
    Class100Klbs = 'Class100Klbs',
    Class130Klbs = 'Class130Klbs',
    ClassGt100Klbs = 'ClassGt100Klbs',
    ClassGt130Klbs = 'ClassGt130Klbs'
}



